import { Component, Input, OnChanges } from '@angular/core';
// import { ViewChild, ElementRef } from '@angular/core';
import { Router, Params } from '@angular/router';
import { Location } from '@angular/common';
import { Product, ProductResponse } from '../../../../models/Product';
import { ProductService } from '../../../../services/product.service';
import { ProductValidatorService } from "../../../../services/validators/product-validator.service";
import { FormComponent } from "../../../../models/FormComponent";
import { FlashService } from '../../../../services/utility/flash.service';
import { HtmlHelperService } from '../../../../services/utility/html-helper.service';
import * as $ from 'jquery'

@Component({
  selector: 'app-admin-product-edit',
  templateUrl: './admin-product-edit.component.html',
  styleUrls: ['./admin-product-edit.component.scss']
})
export class AdminProductEditComponent implements OnChanges {
  @Input('product') originalProduct:Product;  //linked to parent 'admin-products', will initially be null until products are loaded.   //will be null until getProduct responds
  // @ViewChild('apeSku') apeSku:ElementRef;
  sku:string = null;
  product?: Product; //assigned a COPY so that original is maintained to check diff.
  productdate?: Date;  //store properly formatted date

  constructor(
    private router:Router,
    private productService: ProductService,
    private validator:ProductValidatorService,
    private flashService:FlashService,
    private htmlHelper:HtmlHelperService,
    private location: Location
  ) { }


  //*note - urlType is evaluated at admin.component, BEFORE products are loaded in admin-products.component.
  //        Thus, Input('product') will initially be null, so guard against that.
  ngOnChanges(){
    // console.log('ape - onChanges has this.product', this.product);
    //guard against null product
    if(!this.originalProduct){
      return;
    }
    //COPY Product
    this.product = Product.fromJson(this.originalProduct);  //produce an editable copy of 'product'
    this.productdate = new Date(this.originalProduct.updated_at);  //convert timestamp to Date

    //wait a tick for dom to reload with new products.
    // *all settimeout calls must use af to access 'this'.  https://stackoverflow.com/questions/41106125/angular-2-using-this-inside-settimeout
    setTimeout(() => {
      this.htmlHelper.adjustHeightAllTextareas();
    }, 0);
    
    // console.log('this.apeSku', this.apeSku);
  }

  

// adjustHeightAllElements(){
//   //access DOM to modify height of the textarea
//     let textareaList = Array.from(document.getElementsByTagName('textarea') as NodeListOf<HTMLElement>);
//     for (let textarea of textareaList){
//       // console.log('auto-sizing textarea', textarea);
//       textarea.style.overflow = 'hidden';
//       textarea.style.height = '0px';
//       textarea.style.height = textarea.scrollHeight + 'px';
//     }
// }

//moved to htmlhelper service
  // //adjust the height of 
  // adjustHeightSingleElement($e){
  //   console.log('textarea change detected');
  //   let textarea = $e.target;
  //   if(textarea == null){
  //     return;
  //   }
  //   textarea.style.overflow = 'hidden';
  //   textarea.style.height = '0px';
  //   textarea.style.height = textarea.scrollHeight + 'px';
  // }




  onCancelClicked(){
    // console.log('cancel clicked');
    // flash message editing cancelled
    this.flashService.flashMessage.show('Cancelled \'edit product\'.  Changes not saved.', {cssClass:'alert-danger', timeout: 4000});
    this.location.back();
  }

  //TODO: Add a warning popup 'are you sure?' to confirm deletion.
  onDeleteClicked(){
    // console.log('delete clicked');

    this.productService.deleteProduct(this.product).first().subscribe((productResponse:ProductResponse) => {
      if(productResponse.success){
        this.flashService.flashMessage.show('Successfully deleted the product.', {cssClass:'alert-success', timeout:4000});
        this.router.navigate(['/admin/products']);
      } else {
        //flashmessage error
        console.log('ape: error deleting product');
        this.flashService.flashMessage.show(productResponse.msg, {cssClass:'alert-danger', timeout:4000});
      }
    });
  }

  onSubmit({value, valid}:{value:Product, valid:boolean}){
    //manually trigger validation for all fields
    let showErrorsAndAlerts = true;
    this.validator.triggerValidationsForAllFormComponents(showErrorsAndAlerts);
    //assemble the validation errors
    let validationErrors = this.validator.validationErrors();
    // let requiredOnly = true;
    let validationAlerts = this.validator.validationAlerts();
    console.log('validationAlerts', validationAlerts);
    //show error message
    if(validationErrors.length > 0 || validationAlerts.length > 0){
      // issues exist
      let issueCount = validationErrors.length+validationAlerts.length;
      let msg = 'Unable to add product ('+issueCount+' issues).';
      this.flashService.flashMessage.show(msg, {cssClass:'alert-danger', timeout: 4000});
    } else {
      //Update product
      this.productService.editProduct(this.product).first().subscribe((productResponse:ProductResponse) => {
        console.log('pce: res', productResponse);
        if(productResponse.success){
          let editedProduct = productResponse.product;
          this.flashService.flashMessage.show('Successfully saved edits to product.', {cssClass:'alert-success', timeout:4000});
          //also, register the product to show 'saved' on the product-list table
          let flashService = this.flashService;
          setTimeout(function() {
            // console.log('productResponse.product', editedProduct);
            let elementId = '#flashSaved'+editedProduct.sku;
            // console.log('flashing element', element);
            flashService.flashElementWithId(elementId, 'Saved', 4000);
          }, 0);

          this.router.navigate(['/admin/products']);
        } else {
          //flashmessage error
          console.log('pce: error editing product');
          this.flashService.flashMessage.show(productResponse.msg, {cssClass:'alert-danger', timeout:4000});
        }

      })

    }
  }


}





//==============
//Unused Code

// console.log('flextext changeheight on keyup');
// let textarea = $('#productSummary');
// console.log('textarea', textarea);
// // console.log('textarea.scrollHeight', textarea.scrollHeight);  //can't access the scrollheight like this.  used HTMLElement instead.

      // this.clientService.updateClient(this.id, value);
      // this.flashMessagesService.show('Client updated', {cssClass:'alert-success', timeout:4000});
      // this.router.navigate(['/client/'+this.id]);


// No longer needed, using inputs instead.  Let admin-products.component decypher the variable values.
  // //Input products is initially null.  When 'products' loads async, grab product by sku and re-adjust height of textarea boxes.
  // ngOnChanges(changes: SimpleChanges){
  //   this.activatedRoute.params.first().subscribe((params: Params) => {
  //     //use route params to set local properties
  //     this.sku = params["sku"];
  //     //guard against empty products
  //     if (this.products.length == 0){
  //       // console.log('ape - no products')
  //       return;          
  //     } else {
  //       // console.log('ape - has products')
  //     }
  //     let filteredProduct = this.productService.getProductBySku(this.sku);
  //     if(filteredProduct){
  //       let filteredCopy = Product.fromJson(filteredProduct);  //to get a new product copy.
  //       this.product = filteredCopy;  //local has a copy, so we can track changes from original upon save
  //       this.productdate = new Date(this.product.updated_at);  //convert timestamp to Date
  //       //wait a tick for dom to reload with new products.
  //       // *must use af to access 'this'.  https://stackoverflow.com/questions/41106125/angular-2-using-this-inside-settimeout
  //       setTimeout(() => {
  //         this.adjustHeightAllElements();
  //       }, 0);
        
  //     } else {
  //       this.product = null;
  //       this.productdate = null;
  //     }
  //   });
  // }

  // ngOnInit(){
  //   console.log('ape init');
  //   console.log('this.product', this.product);
  // }


  // onSwitchToggle($e){
  //   console.log('$e', $e);
  // }

  // //todo - remove this.  I moved it ape-price instead.
  // updownclicked($event){
  //   // console.log('updownclicked with event', $event);
  //   let e0 = $event.path[0];
  //   let e1 = $event.path[1];
  //   let isUpward = $(e0).hasClass('upward') || $(e1).hasClass('upward');
  //   if (isUpward){
  //     //upward = increase value by $1
  //     let newprice = this.product.product_price + 1;
  //     this.product.product_price = +newprice.toFixed(2);
  //   } else {
  //     //downward = reduce value by $1
  //     let newprice = this.product.product_price - 1;
  //     this.product.product_price = +newprice.toFixed(2);
  //   }
  //   // console.log('new price', this.product.product_price);
  // }

  // if(!valid){
  //   this.flashService.flashMessage.show('Please fill in all fields', {cssClass:'alert-danger', timeout:4000});
  //   // this.router.navigate(['edit-client/'+this.id]);
  // }

  // let validationAlerts = this.validator.validationAlerts(requiredOnly);


// WEBPACK FOOTER //
// ./src/app/components/admin/admin-products/admin-product-edit/admin-product-edit.component.ts